import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, FormField, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const ConsentEnterChildStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [errors, setErrors] = useState<{ name?: string; cpr?: string }>({});
  const [title, setTitle] = useState<string>('Angiv barn');
  const [intro, setIntro] = useState<string>('Indtast barnets navn eller CPR.');

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas_samtykke.consent_enter_child).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);

  const validate = () => {
    const e: { name?: string; cpr?: string } = {};
    if (!selfServiceData.consentChildName?.trim() && !selfServiceData.consentChildCpr?.trim()) {
      e.name = 'Angiv navn eller CPR.';
    }
    if (selfServiceData.consentChildCpr && !/^\d{6}[- ]?\d{4}$/.test(selfServiceData.consentChildCpr)) {
      e.cpr = 'Ugyldigt CPR.';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onNext = () => {
    if (validate()) {goNext();}
  };

  return (
    <StepContainer title={title}>
      <InfoBox type="info"><p>{intro}</p></InfoBox>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <FormField name="consentChildName" value={selfServiceData.consentChildName || ''} placeholder="Barnets navn" error={errors.name} onChange={(e) => updateSelfServiceData('consentChildName', e.target.value)} />
        <FormField name="consentChildCpr" value={selfServiceData.consentChildCpr || ''} placeholder="CPR (valgfrit)" error={errors.cpr} onChange={(e) => updateSelfServiceData('consentChildCpr', e.target.value)} />
      </div>
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default ConsentEnterChildStep;

